export default __webpack_public_path__ + "static/media/xperimentor.6a76bdb6.png";